import classNames from 'classnames';
import { graphql } from 'gatsby';
import React, { ComponentProps, FC } from 'react';

import { Nullable } from '@/types';

export const theme_fragment = graphql`
  fragment SanityTheme on SanityTheme {
    primaryColor {
      hex
    }
    secondaryColor {
      hex
    }
  }
`;

export const Theme: FC<
  ComponentProps<'div'> & { theme: Nullable<Queries.SanityThemeFragment> }
> = ({ children, className, theme, style = {} }) => {
  const styles = {
    ...style,
    '--color-primary': theme?.primaryColor?.hex,
    '--color-secondary': theme?.secondaryColor?.hex,
  };

  return (
    <div className={classNames('min-h-full', className)} style={styles}>
      {children}
    </div>
  );
};
